import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getPopularCalculators } from '../../data/calculators';

const SmartCalculatorsSidebar = ({ currentSlug, rightOffset = '80px' }) => {
  const [isFixed, setIsFixed] = useState(false);
  const sidebarRef = useRef(null);
  const initialTopRef = useRef(0);

  useEffect(() => {
    const initSidebar = () => {
      if (sidebarRef.current) {
        initialTopRef.current = sidebarRef.current.getBoundingClientRect().top + window.scrollY;
      }
    };
    setTimeout(initSidebar, 100);

    const handleScroll = () => {
      if (initialTopRef.current > 0) {
        const shouldFix = (initialTopRef.current - window.scrollY) <= 100;
        setIsFixed(shouldFix);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', initSidebar);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', initSidebar);
    };
  }, []);

  // Get popular calculators, excluding current one
  const sidebarCalculators = getPopularCalculators()
    .filter(calc => calc.slug !== currentSlug)
    .slice(0, 6);

  return (
    <div ref={sidebarRef} style={{ width: '300px', flexShrink: 0 }} className="hidden lg:block">
      <div
        style={{
          position: isFixed ? 'fixed' : 'relative',
          top: isFixed ? '100px' : '0',
          right: isFixed ? rightOffset : 'auto',
          width: '300px',
        }}
      >
        <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8">
          <h3 style={{ fontFamily: 'Onest, sans-serif', fontWeight: 700, fontSize: '18px', color: '#1f2937', marginBottom: '16px' }}>
            Smart Calculators
          </h3>
          <div>
            {sidebarCalculators.map((calc, index) => (
              <Link
                key={calc.slug}
                to={`/calculators/${calc.slug}`}
                style={{
                  fontFamily: 'Onest, sans-serif',
                  color: '#115e59',
                  display: 'block',
                  padding: '12px 0',
                  fontWeight: 500,
                  fontSize: '15px',
                  borderBottom: index < sidebarCalculators.length - 1 ? '1px solid #f3f4f6' : 'none',
                }}
              >
                {calc.shortName}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartCalculatorsSidebar;
